module.exports = __webpack_public_path__ + "static/media/minus.b6f43048.png";